import { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Spinner,
} from "react-bootstrap";
import {
  useCities,
  useCountries,
  useProvinces,
} from "../../Hooks/use-locations";

const DeliveryAddressSelector = ({
  addresses = [],
  selectedAddress,
  setSelectedAddress,
  loadingAddresses,
  setShipping,
  selectedUser,
  setShippingCost
}) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newShipping, setNewShipping] = useState({
    name: "",
    address: "",
    country_id: "",
    province_id: "",
    city_id: "",
    postal_code: "",
    observations: "",
  });

  const { countries } = useCountries(selectedUser?.value);
  const { provinces } = useProvinces(newShipping.country_id);
  const { cities } = useCities(newShipping.province_id);

  const handleChange = (e) => {
    const { name, value } = e.target;
  

    setNewShipping((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };
      setShipping(updated); 
      return updated;
    });

  };

  useEffect(() => {
    if (!showAddForm) return; 

      let cost = 0;

      if (newShipping.city_id) {
        const cityObj = cities.find((c) => c.id === newShipping.city_id);

        if (cityObj?.shippingCost) {
          cost = cityObj.shippingCost;
        } else {
      
          if (newShipping.country_id) {
            const countryObj = countries.find(
              (c) => c.country_id === newShipping.country_id
            );
            if (countryObj?.shippingCost) {
              cost = countryObj.shippingCost;
            }
          }
        }
      }

      setShippingCost(cost);
    },
    [newShipping.city_id, newShipping.country_id,cities,countries,showAddForm]
  );


  const handleSelectSaved = (id) => {
    setSelectedAddress(id);
    setShipping(undefined);
    setShowAddForm(false);
  };

  const handleFormToggle = () => {
    setShowAddForm((v) => !v);
    setSelectedAddress(null);
    setShipping(undefined);
  };



  return (
    <Row className="mt-3">
      <Col md={12}>
        <Form.Label>Dirección de envío</Form.Label>

        {loadingAddresses && <Spinner animation="border" size="sm" />}

        {!loadingAddresses && !showAddForm &&
          addresses.map((address) => (
            <div key={address.id} className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="address"
                id={`addr-${address.id}`}
                value={address.id}
                checked={selectedAddress === address.id}
                onChange={() => handleSelectSaved(address.id)}
              />
              <label className="form-check-label" htmlFor={`addr-${address.id}`}>
                <strong>{address.name}</strong> — {address.address},{" "}
                {address.city_id?.name}, {address.province_id?.name},{" "}
                {address.country_id?.name}, CP: {address.postal_code}
                <br />
                <small>{address.observations}</small>
              </label>
            </div>
          ))}

        {/* Botón para mostrar/ocultar formulario */}
        <div className="d-flex justify-content-end mt-2">
          <Button
            variant={showAddForm ? "secondary" : "outline-primary"}
            size="sm"
            onClick={handleFormToggle}
          >
            {showAddForm ? "Cancelar nueva dirección" : "Ingresar dirección manual"}
          </Button>
        </div>

        {/* Formulario de dirección manual */}
        {showAddForm && (
          <div className="mt-3 p-3 border rounded" style={{ minHeight: "300px" }}>
            <Form.Group className="mb-2">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                name="name"
                value={newShipping.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                name="address"
                value={newShipping.address}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>País</Form.Label>
              <Form.Select
                name="country_id"
                value={newShipping.country_id}
                onChange={handleChange}
              >
                <option value="">Selecciona un país</option>
                {countries.map((c) => (
                  <option key={c.country_id} value={c.country_id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Provincia</Form.Label>
              <Form.Select
                name="province_id"
                value={newShipping.province_id}
                onChange={handleChange}
              >
                <option value="">Selecciona una provincia</option>
                {provinces.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Ciudad</Form.Label>
              <Form.Select
                name="city_id"
                value={newShipping.city_id}
                onChange={handleChange}
              >
                <option value="">Selecciona una ciudad</option>
                {cities.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Código Postal</Form.Label>
              <Form.Control
                name="postal_code"
                value={newShipping.postal_code}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control
                as="textarea" rows={3}
                name="observations"
                value={newShipping.observations}
                onChange={handleChange}
              />
            </Form.Group>

          </div>
        )}
      </Col>
    </Row>
  );
};

export default DeliveryAddressSelector;
